import { getDispatch } from '../get-dispatch';
import { DispatchAction } from '../utility/dispatch-action';
import { SliderActions, SLIDER_STATE_NAMESPACE } from './slider.module-types';

export const dispatchSliderAction: DispatchAction<SliderActions> = getDispatch(
  SLIDER_STATE_NAMESPACE
);
